module.exports = __webpack_public_path__ + "img/area1_061221.fdf2f1ce.jpg";